import React from "react";
import {
  Autocomplete as MUIAutoComplete,
  Chip,
  TextField,
  AutocompleteProps as MUIAutoCompleteProps,
  Tooltip,
} from "@mui/material";

type AutoCompleteProps<T> = MUIAutoCompleteProps<
  string,
  true,
  boolean,
  boolean
> & {
  label?: string;
  maxItem?: number;
  entries?: Filter<T>;
};

const AutoComplete = <T,>(props: AutoCompleteProps<T>) => {
  const {
    value,
    label,
    size = "small",
    maxItem = 2,
    entries,
    options,
    ...other
  } = props;
  return (
    <MUIAutoComplete
      {...other}
      multiple
      value={value}
      renderInput={(params) => <TextField {...params} label={label} />}
      options={options}
      renderTags={(value, getTagProps) => [
        value.slice(0, maxItem).map((option, index) => (
          <Tooltip
            key={index}
            title={
              entries
                ? entries.find((data) => data.value === option)?.label || option
                : option
            }
            arrow
          >
            <Chip
              {...getTagProps({ index })}
              size={size}
              label={
                entries
                  ? entries.find((data) => data.value === option)?.label ||
                    option
                  : option
              }
              sx={(theme) => ({
                "&&": { maxWidth: theme.spacing(11), m: 0, mr: 0.5 },
              })}
            />
          </Tooltip>
        )),

        value.length > maxItem ? ` + ${value.length - maxItem}` : "",
      ]}
    />
  );
};

export default AutoComplete;
